module.exports = __webpack_public_path__ + "img/69.b02d207c.jpg";